module.exports = __webpack_public_path__ + "media/images/guide-thumb-2t-7c664b10370f024980d5799d7e11710f.png";